import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      borderRadius: "15px",
      padding: theme.spacing(2),
      textAlign: "center",
      maxWidth: "500px",
    },
  },
  title: {
    color: theme.palette.error.main,
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  content: {
    margin: theme.spacing(2, 0),
  },
  button: {
    margin: theme.spacing(1),
    borderRadius: "20px",
    padding: theme.spacing(1, 3),
  },
}));

const QuotaExceededModal = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleQuotaError = (event) => {
      setOpen(true);
    };

    window.addEventListener("ERR_QUOTA_EXCEEDED", handleQuotaError);

    return () => {
      window.removeEventListener("ERR_QUOTA_EXCEEDED", handleQuotaError);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleContactSupport = () => {
    // Replace with your support link or action
    window.open("https://wa.me/55...", "_blank");
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.root}
      aria-labelledby="quota-exceeded-title"
      aria-describedby="quota-exceeded-description"
    >
      <DialogTitle id="quota-exceeded-title" className={classes.title}>
        ⚠️ Cota Excedida
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText id="quota-exceeded-description">
          Você atingiu o limite de mensagens do seu plano.
          <br />
          <br />
          Para continuar enviando mensagens, por favor, entre em contato com o
          suporte para adquirir um pacote adicional ou fazer um upgrade do seu
          plano.
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <Button
          onClick={handleClose}
          color="secondary"
          variant="outlined"
          className={classes.button}
        >
          Fechar
        </Button>
        <Button
          onClick={handleContactSupport}
          color="primary"
          variant="contained"
          className={classes.button}
          autoFocus
        >
          Contatar Suporte
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuotaExceededModal;
